var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{hidden:_vm.isMobile},attrs:{"id":"app"}},[_c('div',{staticClass:"header"},[_c('NavBar',{staticClass:"navbar"})],1),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }